import React, { useEffect } from "react";

import PageSkeleton from "../components/PageSkeleton";

function TradingAssets () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <PageSkeleton
            titleKey="pages.trading.title"
            descriptionKey="pages.trading.description"
            sections={[
                "pages.trading.sections.1",
                "pages.trading.sections.2",
                "pages.trading.sections.3",
                "pages.trading.sections.4",
                "pages.trading.sections.5",
                "pages.trading.sections.6",
            ]}
        />
    );
}

export default TradingAssets;
